import { createFileRoute } from '@tanstack/react-router'

import { ModeStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/mode')({
    component: ModeStep,
})
